import { EntityFilterCollection } from '../../../../modules/admin/models/entity-filter';
import { Station } from '../../../../modules/shared-platform/models/location/station';

export class DashboardFilters {
    customers: EntityFilterCollection = new EntityFilterCollection();
    countries?: string[] = [];
    regions?: string[] = [];
    subRegions?: string[] = [];
    stations?: Station[] = [];
    statesProvinces?: string[] = [];
    commodities?: string[] = [];
    loaded?: string[] = [];
}
